
export type MessagingLeaveChatRoom200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
